module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./OtherView.js"));
	}, "OtherSicknessView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OtherSicknessView!./src/pages/Shop/Member/Personal/Sickness/Other/OtherView.js
// module id = 1489
// module chunks = 418